import React from "react";
import TextCopier from "routes/llm_run/llm_run_detail/components/actions/text_copier";
import styled from "styled-components";

const HiddenPre = styled.pre`
  overflow: hidden;
  text-wrap: auto;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: grey;
`;

export function OutputValue({value, hide = false}) {
  const displayValue = value ?? "-";
  const isObject = value !== null && typeof value === "object";
  const text = isObject ? JSON.stringify(value, null, 2) : displayValue;
  const hiddenContent = (
    <>{isObject ? <HiddenPre>{text}</HiddenPre> : displayValue}</>
  );

  if (!hide && value) {
    return <TextCopier text={text} />;
  }

  return hiddenContent;
}
